import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';
/**
 * Coworkhome Search component
 */
export class CoworkHomeSearchComponent extends Component {

    static alias = 'cowork-home-search';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {
        this.suggestNavIdx =  -1;
        this.elSuggestNavLast = null;
        this.elSuggestions = null;
    	this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchFocusOut = this.handleSearchFocusOut.bind(this);
        this.clickSearch = this.clickSearch.bind(this);
        this.clickSearchBox = this.clickSearchBox.bind(this);
        this.handleSelectedFocus = this.handleSelectedFocus.bind(this);
        // Initialize the search box
        this.initializeSearchBox();

        //Initialize search button
        if(globals.pageType!= 'CoworkSNB') {
            this.initializeSearchButton();
        }

        this.initializeSearchTextFieldClick();
    }

    /**
     * Initializes the search box
     */
    initializeSearchBox() {
    	this.refs.coworksearch.addEventListener('input', this.handleSearch);
        this.refs.coworksearch.addEventListener('blur', this.handleSearchFocusOut);
    }


    /**
     * Event handler to load suggestions based on search
     * 
     * @param {KeyboardEvent} param0 the `input` event
     */
    handleSearch({target: {value}}) {

        // Normalize the string prior to usage
        value = value.trim().toLowerCase();
        let cityId = '';
        if(globals.cityId != 1) { 
            cityId = globals.cityId;
        }
        // Render the matching search
        this.fetchSearchSuggestion(value, cityId).then((suggestions) => {
            // Update the state
            this.setState({...this.state, suggestions});
            
            // Render suggestions
            this.renderSearchSuggestions(this.state.suggestions);
        });
    }

    fetchSearchSuggestion(query, cityId) {
    	// Render suggestions
        return fetch(`/homes/re2/coworksearch?query=${query}&cityId=${cityId}`).then((res) => res.json());
    }

    /**
     * Renders search Suggestions
     * @param {Array} suggestions 
     */
    renderSearchSuggestions(suggestions = []) {

        this.refs.searchDropdown.innerHTML = suggestions.reduce((html, search) => html + `
            <li data-value="${search.id}"><a href="${this.generateUrl(search)}">${search.label}<span>${search.category}</span></a></li>
        `, '');

    	if(!this.refs.searchDropdown.parentElement.classList.contains('open')) {
     		this.refs.searchDropdown.parentElement.classList.add('open');
        }
        this.elSuggestions = null;
        this.suggestNavIdx = -1;
        this.elSuggestNavLast = null;
        this.refs.coworksearch.addEventListener('keyup', this.handleSelectedFocus);
    }

    /**
     * Event handler to handle focus out
     * 
     * @param {FocusEvent} param0 the `blur` event
     */
    handleSearchFocusOut(ev) {
        if (!ev.relatedTarget) {
            this.refs.searchDropdown.parentElement.classList.remove('open');
            this.suggestNavIdx = -1;
            this.elSuggestNavLast = null;
            this.elSuggestions = null;
        }
    }
    
    handleSelectedFocus(ev) {
        this.elSuggestions = this.refs.searchDropdown.children;
        const totalSuggestions = this.refs.searchDropdown.childElementCount;
        if (this.elSuggestNavLast) {
            this.elSuggestNavLast.classList.remove('active');
        }
        // Update the cursor
        if (40 === ev.keyCode && this.suggestNavIdx < (totalSuggestions - 1)) {
            this.suggestNavIdx += 1;
            this.elSuggestNavLast = this.elSuggestions.item(this.suggestNavIdx);
            this.elSuggestNavLast.classList.add('active');
        } else if (38 === ev.keyCode && this.suggestNavIdx > 0) {
            this.suggestNavIdx -= 1;
            this.elSuggestNavLast = this.elSuggestions.item(this.suggestNavIdx);
            this.elSuggestNavLast.classList.add('active');
        } else if (13 === ev.keyCode) {
            ev.preventDefault();
            if(this.suggestNavIdx !== -1){
                window.location = this.elSuggestions.item(this.suggestNavIdx).children[0].href;
            }
        }else if(40 === ev.keyCode || 38 === ev.keyCode){
            //ev.preventDefault();
            this.elSuggestNavLast = this.elSuggestions.item(this.suggestNavIdx);
            this.elSuggestNavLast.classList.add('active');
        }else if(37 === ev.keyCode || 39 === ev.keyCode){
            this.suggestNavIdx = -1;
            this.elSuggestNavLast = null;
            this.elSuggestions = null;
        }
    }

    generateUrl(search){
        let url = '';
        if(search.category == 'Partners'){
            url = '';
        } else if(search.category == 'Cowork') {
            let locality = (search.localityName).replace(/\s+/g, '-').toLowerCase();
            let city = (search.cityName).replace(/\s+/g, '-').toLowerCase();
            let coworkName = (search.label).replace(/\s+/g, '-').toLowerCase();
            url = `//www.quikr.com/coworking/listing/${coworkName}-${locality}-${city}-${search.id}`;
        } else if(search.category == 'Locality') {
            let localityName = (search.localityName).replace(/\s+/g, '-').toLowerCase();
            let cityName = (search.cityName).replace(/\s+/g, '-').toLowerCase();
            url = `//www.quikr.com/coworking/coworking-spaces-in-${localityName}-${cityName}-cid_${search.cityId}-lid_${search.id}`;
        }
    return url;
    }

    initializeSearchButton(){
        this.refs.searchButton.addEventListener('click', this.clickSearch);
    }

    initializeSearchTextFieldClick(){
        this.refs.coworksearch.addEventListener('click', this.clickSearchBox);
    }

    clickSearchBox(){
        if (this.elSuggestNavLast) {
            this.elSuggestNavLast.classList.remove('active');
        }
        this.elSuggestions = null;
        this.suggestNavIdx = -1;
        this.elSuggestNavLast = null;
    }

    clickSearch(){
        let urlSuffix = '';
        let cityId = globals.cityId;
        let cityName = globals.cityName;
        if(!isEmpty(cityId) && cityId != 1 && !isEmpty(cityName))
        {
            let city = (cityName).replace(/\s+/g, '-').toLowerCase();
            urlSuffix = `-in-${city}-cid_${cityId}`;
        }
        
        let text = this.refs.coworksearch.value;
        if(!isEmpty(text))
        {
            text = (text).replace(/\s+/g, '+').toLowerCase();
            urlSuffix = `?text=${text}`;
        }
        window.location = `//www.quikr.com/coworking/coworking-spaces${urlSuffix}`;
        
    }


}